import APIClient from '@/shared/http/clients/api'

const resourceName = 'person'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByName = (name, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/name/${name}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const PersonRepository = {
  GetAll,
  GetAllPaging,
  GetAllByName,
  GetById,
  Create,
  Update,
  Delete
}

export default PersonRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/person.js